// import React, { useState } from "react";
// import data from "../../services.json";

// const { ourServices } = data;

// const OurServices = () => {
//   const { id, badge, heading, items } = ourServices;
//   const [modalData, setModalData] = useState(null);
//   const [isClicked, setIsClicked] = useState(false);
//   const viewItems = isClicked ? items : items.slice(0, 6);
//   const openModal = (sub) => {
//     if (sub.detail) setModalData(sub);
//   };

//   const closeModal = () => setModalData(null);

//   return (
//     <section id={id} className="w-full bg-white ava-section-gap">
//       <div className="container mx-auto px-4 md:px-8">
//         {/* ── Badge ── */}
//         <div className="flex justify-center ">
//           {/* <span
//             className="px-5 py-1.5 rounded-full ava-text-body ava-border"
//             style={{
//               backgroundColor: "transparent",
//             }}
//           >
//             {badge}
//           </span> */}
//         </div>
//         {/* ── Heading ── */}
//         <h2
//           className="text-center ava-heading-lg  ava-heading-gap"
//         >
//           {heading}
//         </h2>

//         {/* ── 2-column card grid (1 on mobile) ── */}
//         <div
//           className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5"
//           style={{ maxWidth: "1100px", margin: "0 auto" }}
//         >
//           {viewItems.map((item) => (
//             <ServiceCard key={item.id} item={item} onSubItemClick={openModal} />
//           ))}
//         </div>
//         <div className="" style={{ display: "flex", marginTop: "30px", justifyContent: "center" }}>
//           <button className="btn-primary" onClick={() => setIsClicked(!isClicked)} 
//             disabled={isClicked}
//             >
//             All Services
//             {/* {isClicked ? "Show Less" : "All"} Services */}
//           </button>
//         </div>
//       </div>

//       {modalData && <ServiceModal data={modalData} onClose={closeModal} />}
//     </section>
//   );
// };

// /* ─────────────────────────────────────────────
//    Service Card — horizontal layout:
//    Left: square image | Right: title, description, tag pills
// ───────────────────────────────────────────── */
// const ServiceCard = ({ item, onSubItemClick }) => {
//   return (
//     // <div
//     //   className="flex rounded-2xl overflow-hidden " 
//     //         style={{
//     //     border: "1px solid var(--gray-200)",
//     //     backgroundColor: "#fff",
//     //     boxShadow: "0 2px 12px rgba(0,36,107,0.06)",
//     //     minHeight: "160px",
//     //   }}
//     // >
//     <div className="
//       flex flex-col min-[425px]:flex-row
//       rounded-2xl overflow-hidden
      
//       bg-white ava-card-mukta
//       transition-all duration-200
//     ">
//       {/* ── Left: Image ── */}
//       {/* <div
//         className="flex-shrink-0 relative overflow-hidden"
//         style={{ width: "42%", minWidth: "130px", maxWidth: "200px" }}
//       > */}
//       <div className="
//         w-full h-[180px]
//         min-[425px]:h-auto
//         min-[425px]:w-[40%]
//         min-[425px]:min-w-[140px]
//         min-[425px]:max-w-[200px]
//         relative overflow-hidden flex-shrink-0
//       ">
//         {item.image ? (
//           <img
//             src={item.image}
//             alt={item.title}
//             className="absolute inset-0 w-full h-full object-cover object-center"
//             draggable={false}
//           />
//         ) : (
//           /* Fallback SVG placeholder if no image provided */
//           <div
//             className="absolute inset-0 flex items-center justify-center"
//           >
//             <ServicePlaceholderSVG />
//           </div>
//         )}
//       </div>

//       {/* ── Right: Content ── */}
//       <div className="flex flex-col justify-start p-4 flex-1 min-w-0">
//         {/* Title */}
//         <h3
//           className=" ava-text-subheading mb-1"

//         >
//           {item.title}
//         </h3>

//         {/* Description (optional) */}
//         {item.description && (
//           <p
//             className="text-xs mb-3"
//           >
//             {item.description}
//           </p>
//         )}

//         {/* ── Sub-item tags ── */}
//         {/* {item.subItems && item.subItems.length > 0 && (
//           <div className="flex flex-wrap gap-1.5 mt-2">
//             {item.subItems.map((sub) => (
//               <button
//                 key={sub.id}
//                 onClick={() => onSubItemClick(sub)}
//                 className="ava-text-xs px-2.5 py-1 rounded-full transition-colors duration-150 ava-card-bg "
//                 style={{
//                   border: "1px solid gainsboro",
//                   cursor: sub.detail ? "pointer" : "default",
//                   whiteSpace: "nowrap",
//                 }}
//                 // onMouseEnter={(e) => {
//                 //   if (sub.detail) {
//                 //     e.currentTarget.style.backgroundColor = "var(--ava-light-surface)";
//                 //     e.currentTarget.style.borderColor = "var(--primary-color)";
//                 //   }
//                 // }}
//                 // onMouseLeave={(e) => {
//                 //   e.currentTarget.style.backgroundColor = "var(--ava-light-surface)";
//                 //   e.currentTarget.style.borderColor = "var(--gray-200)";
//                 // }}
//               >
//                 {sub.label}
//               </button>
//             ))}
//           </div>
//         )} */}
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────
//    Fallback SVG — shown when item.image is absent
// ───────────────────────────────────────────── */
// const ServicePlaceholderSVG = () => (
//   <svg
//     width="64"
//     height="64"
//     viewBox="0 0 64 64"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     aria-hidden="true"
//   >
//     <circle
//       cx="32"
//       cy="22"
//       r="10"
//       stroke="var(--primary-color)"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M12 54c0-11.046 8.954-20 20-20s20 8.954 20 20"
//       stroke="var(--primary-color)"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M40 18h8M44 14v8"
//       stroke="#E66000"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// /* ─────────────────────────────────────────────
//    Service Detail Modal
// ───────────────────────────────────────────── */
// const ServiceModal = ({ data, onClose }) => {
//   const { label, detail } = data;

//   const handleBackdrop = (e) => {
//     if (e.target === e.currentTarget) onClose();
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", handler);
//     return () => window.removeEventListener("keydown", handler);
//   }, []);

//   React.useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, []);

//   const fields = [
//     { key: "condition", label: "Condition" },
//     { key: "whatItIs", label: "What It Is" },
//     { key: "whenToSee", label: "When to See a Doctor" },
//     { key: "howEvaluated", label: "How It's Evaluated" },
//     { key: "treatmentOptions", label: "Treatment Options" },
//     { key: "selfCareTips", label: "Self-Care Tips" },
//   ];

//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6"
//       style={{ backgroundColor: "rgba(0,0,0,0.45)" }}
//       onClick={handleBackdrop}
//     >
//       <div
//         className="relative w-full bg-white rounded-2xl overflow-hidden"
//         style={{
//           maxWidth: "900px",
//           maxHeight: "90vh",
//           boxShadow: "0 20px 60px rgba(0,36,107,0.18)",
//         }}
//       >
//         {/* Modal Header */}
//         <div
//           className="flex items-center justify-between px-6 py-4 border-b"
//           style={{ borderColor: "var(--gray-200)" }}
//         >
//           <h3
//             className="ava-text-subheading underline-offset-4"
//           >
//             {label}
//           </h3>
//           <button
//             onClick={onClose}
//             aria-label="Close"
//             className="w-8 h-8 flex items-center justify-center rounded-full transition-colors hover:bg-gray-100 flex-shrink-0"
//           >
//             <svg
//               width="22"
//               height="22"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="1.8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               style={{ color: "var(--text-light)" }}
//             >
//               <circle cx="12" cy="12" r="10" />
//               <line x1="15" y1="9" x2="9" y2="15" />
//               <line x1="9" y1="9" x2="15" y2="15" />
//             </svg>
//           </button>
//         </div>

//         {/* Modal Body */}
//         <div
//           className="overflow-y-auto"
//           style={{ maxHeight: "calc(90vh - 65px)" }}
//         >
//           <div className="flex flex-col sm:flex-row gap-0 p-5 md:p-6">
//             {/* Modal Image or SVG fallback */}
//             <div className="flex-shrink-0 w-full sm:w-56 md:w-64 self-start">
//               <div
//                 className="overflow-hidden rounded-xl ava-card-image"
//                 style={{
//                   height: "220px",
//                 }}
//               >
//                 {detail.image ? (
//                   <img
//                     src={detail.image}
//                     alt={label}
//                     className="w-full h-full object-cover object-center"
//                     draggable={false}
//                   />
//                 ) : (
//                   <div className="w-full h-full flex items-center justify-center">
//                     <ModalPlaceholderSVG />
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Modal Fields */}
//             <div className="flex flex-col gap-3 sm:pl-6 pt-4 sm:pt-0 flex-1 min-w-0">
//               {fields.map(({ key, label: fieldLabel }) =>
//                 detail[key] ? (
//                   <p
//                     key={key}
//                     className="ava-text-body "
//                   >
//                     <span
//                       className=" ava-text-subheading "
//                     >
//                       {fieldLabel}:
//                     </span>{" "}
//                     {detail[key]}
//                   </p>
//                 ) : null,
//               )}
//               {detail.ctaLabel && (
//                 <div className="mt-3">
//                   <a
//                     href={detail.ctaHref || "#book"}
//                     className="btn-primary "
//                   >
//                     {detail.ctaLabel}
//                   </a>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────
//    Modal Placeholder SVG
// ───────────────────────────────────────────── */
// const ModalPlaceholderSVG = () => (
//   <svg
//     width="96"
//     height="96"
//     viewBox="0 0 96 96"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     aria-hidden="true"
//   >
//     <circle
//       cx="48"
//       cy="32"
//       r="16"
//       stroke="var(--primary-color)"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//     />
//     <path
//       d="M16 82c0-17.673 14.327-32 32-32s32 14.327 32 32"
//       stroke="var(--primary-color)"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//     />
//     <path
//       d="M60 26h14M67 19v14"
//       stroke="#E66000"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//     />
//     <circle
//       cx="67"
//       cy="26"
//       r="7"
//       stroke="#E66000"
//       strokeWidth="1.5"
//       strokeDasharray="3 2"
//     />
//   </svg>
// );

// export default OurServices;
import React, { useEffect, useState } from "react";
import data from "../../services.json";
import { ServiceCard, serviceImages } from "../Home/KeyServices";

const { ourServices } = data;

const OurServices = () => {
  const { id, badge, heading, items } = ourServices;
   const [services, setServices] = useState([]);
  const [modalData, setModalData] = useState(null);

  const openModal = (sub) => {
    if (sub.detail) setModalData(sub);
  };
const orgId=`6a352e39ab22c07f82b4261a`;
// https://api.avexa.net/clinic-onboarding/clinics/${clinicId}/services/logo?objectKey=${data.logoUrl}

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(
          `https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services`
        );

        if (!res.ok) throw new Error("Failed to fetch services");

        const data = await res.json();
        console.log(data,"this isthedata")
        setServices(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchServices();
  }, []);

  
  const closeModal = () => setModalData(null);
// const visibleItems = services.map((service) => ({
//   ...service,
//   image:
//     serviceImages[service.serviceName] ||
//     "/images/default.jpg",
// }));
const visibleItems = services.filter(s=>s.status!=="INACTIVE").map((service) => ({
  ...service,
  image: service.logoUrl
    ? `https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services/logo?objectKey=${encodeURIComponent(service.logoUrl)}`
    : serviceImages[service.serviceName] || "/images/default.jpg",
}));
  return (
    <section id={id} className="w-full bg-white py-10 md:py-14">
      <div className="container mx-auto px-4 md:px-8">
        {/* ── Badge ── */}
        {/* <div className="flex justify-center mb-4">
          <span
            className="px-5 py-1.5 rounded-full ava-text-body ava-border"
            style={{
             
              backgroundColor: "transparent",
            }}
          >
            {badge}
          </span>
        </div> */}

        {/* ── Heading ── */}
        <h2
          className="text-center ava-heading-lg  mb-8 md:mb-10"
         
        >
          {heading}
        </h2>

        {/* ── 2-column card grid (1 on mobile) ── */}
        <div
          // className="flex gap-4 md:gap-5"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5"
          style={{  margin: "0 auto" }}
          // maxWidth: "1100px",
        >
          {visibleItems.map((item) => (
            // <ServiceCard key={item.id} item={item} onSubItemClick={openModal} />
            
            <ServiceCard key={item.id} item={item}  enableBookNowButton={true}/>
          ))}
        </div>
      </div>

      {modalData && <ServiceModal data={modalData} onClose={closeModal} />}
    </section>
  );
};
const ServiceModal = ({ data, onClose }) => {
  const { label, detail } = data;

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  React.useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  React.useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const fields = [
    { key: "condition", label: "Condition" },
    { key: "whatItIs", label: "What It Is" },
    { key: "whenToSee", label: "When to See a Doctor" },
    { key: "howEvaluated", label: "How It's Evaluated" },
    { key: "treatmentOptions", label: "Treatment Options" },
    { key: "selfCareTips", label: "Self-Care Tips" },
  ];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6"
      style={{ backgroundColor: "rgba(0,0,0,0.45)" }}
      onClick={handleBackdrop}
    >
      <div
        className="relative w-full bg-white rounded-2xl overflow-hidden"
        style={{
          maxWidth: "900px",
          maxHeight: "90vh",
          boxShadow: "0 20px 60px rgba(0,36,107,0.18)",
        }}
      >
        {/* Modal Header */}
        <div
          className="flex items-center justify-between px-6 py-4 border-b"
          style={{ borderColor: "var(--gray-200)" }}
        >
          <h3
            className="ava-text-subheading underline-offset-4"
          >
            {label}
          </h3>
          <button
            onClick={onClose}
            aria-label="Close"
            className="w-8 h-8 flex items-center justify-center rounded-full transition-colors hover:bg-gray-100 flex-shrink-0"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ color: "var(--text-light)" }}
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div
          className="overflow-y-auto"
          style={{ maxHeight: "calc(90vh - 65px)" }}
        >
          <div className="flex flex-col sm:flex-row gap-0 p-5 md:p-6">
            {/* Modal Image or SVG fallback */}
            <div className="flex-shrink-0 w-full sm:w-56 md:w-64 self-start">
              <div
                className="overflow-hidden rounded-xl"
                style={{
                  height: "220px",
                }}
              >
                {detail.image ? (
                  <img
                    src={detail.image}
                    alt={label}
                    className="w-full h-full object-cover object-center"
                    draggable={false}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <ModalPlaceholderSVG />
                  </div>
                )}
              </div>
            </div>

            {/* Modal Fields */}
            <div className="flex flex-col gap-3 sm:pl-6 pt-4 sm:pt-0 flex-1 min-w-0">
              {fields.map(({ key, label: fieldLabel }) =>
                detail[key] ? (
                  <p
                    key={key}
                    className="ava-text-body "
                  >
                    <span
                      className=" ava-text-subheading "
                    >
                      {fieldLabel}:
                    </span>{" "}
                    {detail[key]}
                  </p>
                ) : null,
              )}
              {detail.ctaLabel && (
                <div className="mt-3">
                  <a
                    href={detail.ctaHref || "#book"}
                    className="btn-primary "
                  >
                    {detail.ctaLabel}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────
   Modal Placeholder SVG
───────────────────────────────────────────── */
const ModalPlaceholderSVG = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle
      cx="48"
      cy="32"
      r="16"
      stroke="var(--primary-color)"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M16 82c0-17.673 14.327-32 32-32s32 14.327 32 32"
      stroke="var(--primary-color)"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M60 26h14M67 19v14"
      stroke="#E66000"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle
      cx="67"
      cy="26"
      r="7"
      stroke="#E66000"
      strokeWidth="1.5"
      strokeDasharray="3 2"
    />
  </svg>
);

export default OurServices;